/**
 * SecretField — one secret on the Team page: masked by default (prefix and
 * last 4), with Reveal/Hide and Copy. Copy works without revealing.
 * `maskSecret` lives here now and is re-exported from ./index.
 */
import { useState } from "react";

const URL_PATH = "/mcp/team-log/";
const KEY_PREFIX = "relay_wk_live_";

/** Prefix and last 4 characters, e.g. relay_wk_live_…MwN4. Never contains the middle of the secret. */
export function maskSecret(value: string): string {
  const keyAt = value.indexOf(KEY_PREFIX);
  const pathAt = value.indexOf(URL_PATH);
  const head = keyAt >= 0 ? value.slice(0, keyAt + KEY_PREFIX.length) : pathAt >= 0 ? value.slice(0, pathAt + URL_PATH.length) : "";
  return `${head}…${value.slice(-4)}`;
}

export function SecretField({
  value, startRevealed = false, copyLabel = "Copy", testId = "secret-value",
}: {
  value: string;
  startRevealed?: boolean;
  copyLabel?: string;
  testId?: string;
}) {
  const [revealed, setRevealed] = useState(startRevealed);
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard unavailable — the label stays "Copy" so the person knows it didn't work.
    }
  }

  return (
    <div className="tp-secret">
      <div className="tp-secret-value" data-testid={testId}>{revealed ? value : maskSecret(value)}</div>
      <button className="tp-btn-xs" onClick={() => setRevealed((r) => !r)}>{revealed ? "Hide" : "Reveal"}</button>
      <button className="tp-btn-xs" onClick={handleCopy}>{copied ? "✓ Copied" : copyLabel}</button>
    </div>
  );
}
